import { Box } from '@factorialco/deprecated-design-system'
import { F0Button } from '@factorialco/f0-react'
import { Delete } from '@factorialco/f0-react/icons/app'

import Modal from 'modules/core/components/Modal'
import { handleResult } from 'modules/core/lib/handleMutation'
import i18n from 'modules/core/lib/i18n'
import { track, trackingEvents } from 'modules/core/lib/Tracking'
import app from 'modules/core/store/models/app'

import { getTextFromNodeType, getTextFromNodeTypePlural } from 'modules/job_catalog/lib/nodesUtils'

import { useDeleteJobCatalogTreeNode } from './useDeleteJobCatalogTreeNode'

interface Props {
  nodeId: string
  nodeName: string
  nodeType: string
  childrenNodeType: string
  onSubmit: (success: boolean) => void
  onClose: () => void
  canBeDeleted: boolean
}
const DeleteModal = ({
  nodeId,
  nodeName,
  nodeType,
  childrenNodeType,
  onSubmit,
  onClose,
  canBeDeleted,
}: Props) => {
  const title = canBeDeleted
    ? i18n.t('job_catalog.nodes.delete.title', { node: nodeName })
    : i18n.t('job_catalog.nodes.delete.title_not_empty', { node: nodeName })
  const description = canBeDeleted
    ? i18n.t('job_catalog.nodes.delete.description_with_node_type', {
        nodeType: getTextFromNodeType(nodeType),
      })
    : i18n.t('job_catalog.nodes.delete.description_not_empty', {
        node: getTextFromNodeType(nodeType),
        childrenNodeType: getTextFromNodeTypePlural(childrenNodeType),
      })

  const { deleteNode } = useDeleteJobCatalogTreeNode()
  const deleteAction = async () => {
    const result = await deleteNode(nodeId)
    const handled = handleResult(result, (resultErrors) => {
      app.setFlash({
        type: 'wrong',
        message: resultErrors.errors || i18n.t('errors.generic_error'),
      })
    })
    track(trackingEvents.jobCatalog.deleteNodeSubmit, {
      event_category: 'Organizations',
      node_type: nodeType,
      node_id: nodeId,
    })
    if (handled.success) {
      app.setFlash({
        type: 'correct',
        message: i18n.t('job_catalog.nodes.delete.success'),
      })
    }
    onSubmit(handled.success)
  }

  return (
    <Modal
      illustration={'alert'}
      title={title}
      description={description}
      onClose={onClose}
      footer={
        <Box gap="s16" flexDirection="row" alignItems="center">
          <F0Button
            label={i18n.t('job_catalog.nodes.delete.cancel')}
            onClick={onClose}
            variant="outline"
          />
          {canBeDeleted && (
            <F0Button
              variant="default"
              icon={Delete}
              onClick={deleteAction}
              label={i18n.t('job_catalog.nodes.delete.submit')}
            />
          )}
        </Box>
      }
    ></Modal>
  )
}

export default DeleteModal
